import * as React from 'react';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
import { GetLanguageSet_translations_getLanguageSet_data_languageCounts as LanguageCounts } from 'translations/queries/__generated__/GetLanguageSet';
import SettingsStore from 'stores/SettingsStore';
import MenuItem from 'components/MenuItem';

type Props = {
  defaultLanguageCode: string;
  shouldTranslate: boolean;
  languageCount: LanguageCounts;
  onSelect: (languageCode: String) => void;
  disabled: boolean;
};

export const TranslationsHoverCardRow = (props: Props) => {
  const languages = SettingsStore.getLanguages();
  const secondaryLanguage = languages?.secondary;

  const { languageCount, shouldTranslate, defaultLanguageCode, onSelect, disabled } = props;

  const { languageCode, count } = languageCount;
  const languageString =
    (secondaryLanguage && secondaryLanguage[languageCode]) ?? 'No preference set';
  const subTextColor = shouldTranslate ? 'graphite' : 'graphite';

  return (
    <MenuItem
      data-test={`translations-hover-card-row-${languageCode}`}
      menuKey={languageCode}
      onSelect={onSelect}
      disabled={disabled}
      noHover={disabled}>
      <MediaObject gutter="xsmall" figure="left">
        <Text size="small" color={shouldTranslate ? 'graphite' : 'graphite'} lineHeight="flush">
          {languageString}
        </Text>
        <MediaObject gutter="small">
          <Text weight="normal" size="xxsmall" align="left" color={subTextColor}>
            {count} {count > 1 ? 'recipients' : 'recipient'}
          </Text>
          {languageCode === defaultLanguageCode && (
            <Text align="right" size="xxsmall" weight="normal" color={subTextColor}>
              Original
            </Text>
          )}
        </MediaObject>
      </MediaObject>
    </MenuItem>
  );
};

export default TranslationsHoverCardRow;
